import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/groves/')({
  beforeLoad: () => {
    throw redirect({ to: '/today', search: { tab: 'groves' }, replace: true })
  },
})
